import React from "react";
import classes from "./ImageContent.module.scss";
import TrapeziumDivider from "@/components/TrapeziumDivider/TrapeziumDivider";
import LatestNewsMobile from "./ImageContentMobile/ImageContentCardMobile";
import ImageContentCard from "./ImageContentCard/ImageContentCard";
import { ArticleCardInfo } from "@/app/(dashboard)/Types";

interface LatestNewsProps {
  error?: string;
  seeAllLink?: boolean;
  numItemsToShow?: number;
  title?: string;
  trapeziumDividerClass?: string;
  data?: ArticleCardInfo[];
}

const ImageContent: React.FC<LatestNewsProps> = ({
  numItemsToShow = 4,
  title,
  trapeziumDividerClass,
  data,
}) => {
  return (
    <>
      <div className={classes["latestNewsMobileContainer"]}>
        <LatestNewsMobile
          title={title}
          data={data}
          numItemsToShow={numItemsToShow}
          trapeziumDividerClass={trapeziumDividerClass}
        />
      </div>

      <div className={classes["latestNewsContainer"]}>
        {title && (
          <>
            <div className={classes["title"]}>{title}</div>
            <TrapeziumDivider customClassName={trapeziumDividerClass} />
          </>
        )}
        <div className={classes["newsCards"]}>
          {(data || []).length > 0 ? (
            data?.slice(0, numItemsToShow).map((el: any, index: any) => (
              <React.Fragment key={index}>
                <ImageContentCard news={el} />
              </React.Fragment>
            ))
          ) : (
            <div className={classes["no-data"]}>No news available.</div>
          )}
        </div>
      </div>
    </>
  );
};

export default ImageContent;
